<template>

  <template v-if="disabled_button == true">
    <button type="button" class="btn-destroy-disabled">
      <i class="fa-solid fa-trash-can" />
      <span class="space-icon" />{{ label }}
    </button>
  </template>
  <template v-else>
    <button type="button" class="btn-destroy" @click.prevent="openModal()">
      <i class="fa-solid fa-trash-can" />
      <span v-if="label" class="space-icon" />{{ label }}
    </button>
    <TransitionRoot as="template" v-if="open" :show="open">
      <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="closeModal()">
        <div class="
          flex
          items-center
          justify-center
          min-h-screen
          pt-4
          px-4
          pb-20
          text-center
          sm:block sm:p-0
        ">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div class="
              relative
              inline-block
              align-bottom
              bg-white
              rounded-lg
              px-8
              pt-5
              pb-4
              text-left
              overflow-hidden
              shadow-xl
              transform
              transition-all
              sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6
            ">
              <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button type="button" class="
                  bg-white
                  rounded-md
                  text-gray-400
                  hover:text-slate-500
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-white
                " @click="closeModal()">
                  <span class="sr-only">Close</span>
                  <i class="h-6 w-6 fa-solid fa-xmark"></i>
                </button>
              </div>
              <form @submit.prevent="submit">
                <div class="sm:flex sm:items-start">
                  <div class="mt-3 sm:mt-0 sm:ml-4 sm:text-left sm:w-full">
                    <DialogTitle class="text-lg leading-6 font-medium text-gray-900">
                      {{ title }}
                    </DialogTitle>

                    <div class="py-5">
                      <div class="grid grid-cols-1 md:grid-cols-2">
                        <div class="col-span-6 sm:col-span-3">
                          <p>{{ message }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5 sm:mt-4 flex flex-row-reverse">
                  <button @click.prevent="$emit('destroy-event')" type="submit" :class="[
                    ' w-full md:w-min inline-flex justify-center py-2 px-4 border shadow-sm text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-red-700 border-red-700 text-white hover:bg-red-700 focus:ring-red-500',
                  ]">
                    {{ label_confirm }}
                  </button>
                </div>
              </form>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </template>
</template>

<script>
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

export default {
  name: "DestroyButton",
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  },
  props: ["label", "title", "message", "label_confirm", "disabled_button"],
  emits: ["destroy-event"],
  data() {
    return {
      open: false,
    };
  },
  methods: {
    openModal: function () {
      this.open = true;
    },
    closeModal: function () {
      this.open = false;
    },
  },
};
</script>
